/* eslint-disable import/prefer-default-export */
export const getUserName = state => state.name
